module.exports = __webpack_public_path__ + "media/packs/images/flags/PL-0416c2f3c05e338996af7cf0694b6e30.svg";